import React, { useState } from 'react';

const validationRulesData = [
  { key: 'size', label: 'Size', type: 'Required', desc: 'Here you have to enter products size name which show in the visualizer.', example: '600 X 300 MM', category: 'Required Fields' },
  { key: 'application_type', label: 'Application Type', type: 'Required', desc: 'Here you have to enter the tile application type such as floor or wall.', example: '600', category: 'Required Fields' },
  { key: 'surface_type', label: 'Surface Type', type: 'Required', desc: 'Here you have to enter surface type. You can enter multiple comma separate.', example: 'Glossy, Matt', category: 'Required Fields' },
  { key: 'sku', label: 'SKU', type: 'Required', desc: 'Here you have to enter product SKU code unique number for identity of product, it helps to update products', example: 'CDB-WT-600-001', category: 'Required Fields' },
  { key: 'width', label: 'Size Width', type: 'Required', desc: 'Here you have to enter the width of the product in mm.', example: '300', category: 'Required Fields' },
  { key: 'price', label: 'Price', type: 'Optional', desc: 'Here you have to enter product price.', example: '500', category: 'Others' },
  { key: 'price_type', label: 'Price Type', type: 'Optional', desc: 'Here you have to price unit such as box, sqft, sqmr .', example: 'Box', category: 'Others' },
  
  { key: 'image_path', label: 'Image Path', type: 'Required', desc: 'Here you have to enter product image URL.', example: 'https://cdn.tilesview.ai/.../tile.webp', category: 'Required Fields' },
];


export default function ValidationRules() {
  const [filter, setFilter] = useState('All');

  const filteredRules = validationRulesData.filter((rule) => {
    if (filter === 'All') return true;
    if (filter === 'Required Fields') return rule.type === 'Required';
    return rule.category === filter;
  });

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm h-full flex flex-col font-sans">
      <h3 className="text-sm font-bold text-gray-800 mb-3">CSV Field Validation Rules</h3>
      
      {/* Category Tabs */}
      <div className="flex gap-2 mb-4 text-xs font-medium">
        {['All', 'Required Fields', 'Packaging Details', 'Others'].map((tab) => (
          <button
            key={tab}
            onClick={() => setFilter(tab)}
            className={`px-3 py-1.5 rounded-full transition-all ${
              filter === tab
                ? 'bg-gray-700 text-white font-semibold'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Rules List (Scrollable) */}
      <div className="overflow-y-auto max-h-[480px] space-y-3 pr-2 divide-y divide-gray-100">
        {filteredRules.map((rule) => (
          <div key={rule.key} className="pt-3 first:pt-0">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs font-semibold text-indigo-600 font-mono">
                {rule.key} <span className="text-gray-400 font-sans font-normal">→ {rule.label}</span>
              </span>
              <span className="text-[10px] bg-red-50 text-red-500 font-semibold px-2 py-0.5 rounded">
                {rule.type}
              </span>
            </div>
            <p className="text-xs text-gray-500 leading-snug">{rule.desc}</p>
            <p className="text-[11px] text-gray-400 mt-1">
              <strong className="font-semibold text-gray-500">Example</strong> {rule.example}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}